import { useContext, useRef, useState, useEffect } from "react";
import {
  Button,
  SelectBox,
  SelectBoxItem,
  Toast,
  Chip,
  Switch,
} from "../../../../../components";
import style from "./Config.module.css";
import classNames from "classnames/bind";
import { SettingAIContext } from "../../../../../contexts";
import { checkTimeHouse, convertTimePM, listAiTranslate, listParamLevelTranslate, listParamTranslate, SCECHULE } from "../../../../../utils";
import { configDefault } from "../../../../../services/api/configDefault";
import { aiConfigService } from "../../../../../services/api/aiConfigService";
import { aiConfigFRS } from "../../../../../services/api/aiConfigFRS";
import streamingClient from "../../../../../services/streamingClient";
import { useTranslation } from "react-i18next";
import { InputNumber } from "antd";
const cx = classNames.bind(style);

function ConfigValue() {
  const {
    listParamsConfig,
    onClose,
    permissionChange,
    nameService,
    codeService,
    handleChangeParamsConfig,
    turnOnAIService,
    reGetData,
    mergeDataDefault,
    getListParams,
    setIsLoading,
    setReGetData,
    setIsUpDate,
    aiConfig,
    setAiConfig,
    start,
    setStart,
    end,
    setEnd,
    full,
    setFull,
    isSound,
    setIsSound,
    deleteIfOff,
    setDeleteIfOff,
    getDefaultConfig,
    setTypeCamera,
    typeCamera,
    nhay,
    setNhay,
    titleAlrm,
    configAlrm,
    setConfigAlrm,
    aiStatus,
    turnOffAIService,
    cameraCode,
    isChanged,
    showReload,
    setShowReload
  } = useContext(SettingAIContext);
  //start
  const ref = useRef();
  const refBtn = useRef();
  const [isFormTime, setIsFormTime] = useState(false);
  const { t } = useTranslation()
  const changeInfoParam = (data, code) => {
    const dataForm = [...listParamsConfig];
    const newData = dataForm.map((param) => {
      if (code === param.AI_PARAM_CODE) {
        let level = [...param.LEVEL];
        let index = param.LEVEL.findIndex((item) => item.CODE === data);
        let itemParam = level.splice(index, 1);
        let name = itemParam[0].PARAM_LEVEL;
        return {
          ...param,
          DEFAULT_LEVEL_CODE: data,
          DEFAULT_LEVEL_NAME: name,
        };
      } else {
        return param;
      }
    });
    handleChangeParamsConfig(newData);
  };
  // // console.log(aiStatus);
  // lấy danh sách cấu hình mặc định của các AI trong hệ thống
  const getListDefaultConfig = async (serviceCode) => {
    try {
      const res = await configDefault.getAllConfig();
      if (res && res?.data) {
        const listConfigDefault = res?.data?.filter(item => item?.TYPE === serviceCode || item?.TYPE === "AI")
        return listConfigDefault;
      }
      return []
    } catch (error) {
      // // console.log('getListDefaultConfig', error);
    }
  }

  const getUnitParam = (listParram, serviceCode, cameraCode) => {
    let time_keeping = "14";
    let code = [];
    let commonConfig = {};
    if (listParram) {
      time_keeping = listParram?.find(pram => pram?.KEY === "TIME_KEEPING_EVENT_DEFAULT")?.VALUE;
      const listAiParam = listParram?.filter(param => !SCECHULE.some(key => key === param?.KEY))
      const listCommonParam = listParram?.filter(param => SCECHULE.some(key => key === param?.KEY)
        && param?.KEY !== "TIME_KEEPING_EVENT_DEFAULT"
        && param?.KEY !== "TIME_ALERT_EVENT"
        && param?.KEY !== "CARE_CLASSES")
      listAiParam?.forEach(aiPa => {
        code.push(aiPa?.VALUE)
      });
      listCommonParam?.forEach(comParam => {
        switch (comParam?.KEY) {
          case "TIME_START_ACTIVE":
            commonConfig.time_start = comParam?.VALUE
            break;
          case "TIME_END_ACTIVE":
            commonConfig.time_end = comParam?.VALUE
            break;
          default:
            commonConfig[`${comParam?.KEY?.toLowerCase()}`] = comParam?.VALUE
            break;
        }
      })
      return {
        time_keeping,
        infoConfig: {
          ai_param_level_code: { code: code },
          ai_service_code: serviceCode,
          camera_code: cameraCode,
          ...commonConfig
        }
      }
    }
  }

  // lấy thông tin cam để kiểm tra xem phát hiện chuyển động có bật không
  const getCameraInfoAi = async (serviceCode) => {
    try {
      const res = await aiConfigService.get({ cameraCode, serviceCode });
      let isMotion = res?.length > 0 ? true : false;
      return isMotion;
    } catch (error) {
    }
  };

  // Bật dịch vụ thông thường
  const handleTurnOnNormalAi = async (cameraCode, serviceCode) => {
    try {
      const isMotion = await getCameraInfoAi(serviceCode)
      if (!isMotion) {
        const defaultConfig = await getListDefaultConfig(serviceCode);
        const paramAiConfig = getUnitParam(defaultConfig, serviceCode, cameraCode)
        // Cấu hình thời gian lưu trữ, cần có time_keeping và camera_code _ aiConfigService.configAi
        const timeKeepingInfo = {
          cameraid: cameraCode,
          time_keeping: paramAiConfig?.time_keeping ? Number(paramAiConfig?.time_keeping) : 14
        }
        await aiConfigService.configAi(timeKeepingInfo)
        // Cấu hình khác aiConfigService.update
        await aiConfigService.update(paramAiConfig.infoConfig)
      }
    } catch (error) {
      // // console.log('handleTurnOnNormalAi', error);
    }
  }
  // Tắt nhận dạng mặt
  const handleTurnOffFaceDetect = async (serviceCode, cameraCode) => {
    try {
      const param = {
        camera_code: cameraCode,
        ai_service_code: serviceCode
      }
      await aiConfigFRS.deleteConfig(param)
    } catch (error) {
      // // console.log("handleTurnOffFaceDetect", error);
    }
  }

  // Lấy dang sách AI đang bật
  const getListAIOn = async (cameraCode) => {
    try {
      const res = await streamingClient.post(
        "/streamManagement/post-list-path-streaming/",
        {
          list_camera: {
            data: [{ camera_code: cameraCode }],
          },
        }
      );
      if (res) {
        // loại bỏ báo cháy
        const listAi = res?.stream[0]?.list_ai_service?.filter(ai => ai?.ai_service_code !== "20230222000000000007");
        // // console.log("listAIOn", res);
        return listAi
      }
      return []
    } catch (error) {
      // // console.log("getListAIOn", error);
    }
  }

  // Tắt các AI khác
  const turnOffOtherAIService = async (cameraCode, aiServiceCode) => {
    if (aiServiceCode && cameraCode) {
      setIsLoading(true);
      try {
        const res = await aiConfigService.remove(cameraCode, aiServiceCode);
        // Toast.open(`Tắt ${nameService} thành công`, "success");
        // setIsLoading(false);
        return res;
      } catch (error) {
        // Toast.open(`Tắt ${nameService} không thành công`, "danger");
        // setIsLoading(false);
        // // console.log(error);
      }
    }
    return 0;
  };

  // Bật các ai khác chuyển động cần check nesu chưa bật chuyển động thì bật lên
  // Nếu tắt chuyển động tắt các ai còn lại 
  // Hai nội dung trên không cần thực hiện với báo cháy
  const handleUpdate = async () => {
    if (permissionChange) {
      if (!checkTimeHouse(start, end)) {
        if (aiStatus) {
          await turnOnAIService();
          if (
            codeService !== "20230222000000000001"
            && codeService !== "20230222000000000006"
            && codeService !== "20230222000000000008"
          ) {
            await handleTurnOnNormalAi(cameraCode, "20230222000000000001")
          }
          setReGetData(!reGetData);
        } else {
          if (codeService !== "20230222000000000001") {
            await turnOffAIService(cameraCode, codeService)
          } else {
            const listAIOn = await getListAIOn(cameraCode);
            // Tắt toàn bộ các AI khác khi tắt chuyển động
            if (listAIOn && listAIOn?.length > 0) {
              for (const ai of listAIOn) {
                if (
                  ai?.ai_service_code !== "20230222000000000002"
                  && ai?.ai_service_code !== "20230222000000000006"
                  && ai?.ai_service_code !== "220230222000000000008"
                ) {
                  // nhận dạng mặt và biển số thì ko cần làm gì cả
                  if (ai?.ai_service_code === "20230222000000000001") {
                    await turnOffAIService(cameraCode, ai?.ai_service_code)
                  } else {
                    await turnOffOtherAIService(cameraCode, ai?.ai_service_code)
                  }
                }
              }
            }

          }
        }
      }
      else {
        Toast.open(t("setting.Start_time_must_be_less_than_end_date"), "danger")
      }
    } else {
      Toast.open(t("setting.You_do_not_have_permission_to_configure_AI"), "danger");
    }
  };
  const handleResetConfig = async () => {
    setIsLoading(true);
    if (permissionChange) {
      setIsUpDate(true);
      const param = await getListParams(codeService);
      const dataDefault = await getDefaultConfig();
      const formatData = await mergeDataDefault(param, []);
      const listParamValue = formatData.map((item) => {
        const dfItem = dataDefault.find(
          (it) => it.KEY.toLowerCase() === item.PARAM
        );
        return {
          ...item,
          DEFAULT_LEVEL_CODE: dfItem?.AI_PARAM_LEVEL_CODE
            ? dfItem.AI_PARAM_LEVEL_CODE
            : 1,
          DEFAULT_LEVEL_NAME: item?.LEVEL
            ? item.LEVEL.find(
              (i) =>
                i.CODE ===
                (dfItem?.AI_PARAM_LEVEL_CODE ? dfItem.AI_PARAM_LEVEL_CODE : 1)
            )?.PARAM_LEVEL
            : "Tất cả",
        };
      });
      if (nameService === "Cảnh báo cháy") {
        setConfigAlrm({
          ...configAlrm,
          alarm: dataDefault[0]?.VALUE,
        })
      } else {
        handleChangeParamsConfig(listParamValue);
      }
      setIsLoading(false);
    } else {
      Toast.open(t("setting.You_do_not_have_permission_to_configure_AI"), "danger");
    }
  };
  const handleChangeTimeKepping = (e) => {
    if (aiConfig && e.target.value <= aiConfig?.TIME_KEEPING_DEFAULT) {
      setShowReload(true)
      setAiConfig({
        ...aiConfig,
        TIME_KEEPING: e.target.value,
      });
    } else {
      Toast.open(t("setting.Number_of_days_retained_is_greater_than_default_number_of_days"), "danger");
    }
  };
  const handleChangeTimeAlert = (e) => {
    if (e.target.value > 0) {
      setAiConfig({
        ...aiConfig,
        TIME_ALERT_EVENT: e.target.value,
      });
    } else {
      Toast.open(t('setting.Red_alert_time_is_greater_than'), "danger");
    }
  };
  useEffect(() => {
    let handler = (e) => {
      if (!refBtn?.current?.contains(e.target)) {
        if (!ref?.current?.contains(e.target)) {
          setIsFormTime(false);
        }
      }
    };
    document.addEventListener("click", handler);
    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  const handleCancel = () => {
    // onClose();
    setReGetData(!reGetData)
  }
  return (
    <>
      <div className={cx("list-config")}>
        <div className={cx("list-config-name")}>
          {t("smartReport.config")} {listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr?.toLowerCase() || nameService?.toLowerCase()}
        </div>
        {/* Tạm thời ẩn đi các chức năng khác với cảnh báo cháy*/}
        {/* {nameService !== "Cảnh báo cháy" && ( */}
        <div className={cx("item-setting")}>
          <span className={cx("name")}>{t("setting.Delete_records_when_service_is_turned_off")}</span>
          <span
            style={{ position: "relative", right: 0, marginTop: 0 }}
            className={cx("info")}
          >
            <Switch
              // value={deleteIfOff === 1 ? true : false}
              value={deleteIfOff}
              type="small"
              onChange={(data) => {
                setShowReload(true)
                setDeleteIfOff(data)
              }}
            />
          </span>
        </div>

        <div className={cx("item-setting")}>
          <span className={cx("name")}>
            {t("setting.Zoom_in_on_screen_when_warning_is_detected")}
          </span>
          <span
            style={{ position: "relative", right: 0, marginTop: 0 }}
            className={cx("info")}
          >
            <Switch
              value={full}
              // value={full === 1 ? true : false}
              type="small"
              onChange={(data) => {
                setShowReload(true)
                setFull(data)
              }}
            />
          </span>
        </div>
        <div className={cx("item-setting")}>
          <span className={cx("name")}>{t('setting.Turn_on_sound')}</span>
          <span
            style={{ position: "relative", right: 0, marginTop: 0 }}
            className={cx("info")}
          >
            <Switch
              value={isSound}
              // value={isSound === 1 ? true : false}
              type="small"
              onChange={(data) => {
                setShowReload(true)
                setIsSound(data)
              }}
            />
          </span>
        </div>
        {/* Tạm thời ẩn đi các chức năng khác với cảnh báo cháy*/}
        {nameService !== "Cảnh báo cháy" && (
          <>
            <div className={cx("item-setting")}>
              <span className={cx("name")}>{t('setting.AI_Storage_Time')}</span>
              <input
                onChange={(e) => handleChangeTimeKepping(e)}
                max={14}
                min={1}
                className={cx("date")}
                type="number"
                value={aiConfig?.TIME_KEEPING}
              />
            </div>
            <div
              style={{ cursor: "pointer", position: "relative" }}
              className={cx("item-setting")}
            >
              <span style={{ flex: 1 }} className={cx("name")}>
                {t('settingCam.Time_frame_allowed')}
              </span>
              <span
                style={{
                  flex: 2,
                  display: "flex",
                  gap: 6,
                  flexWrap: "wrap",
                  flexDirection: "row-reverse",
                  marginTop: 0,
                }}
                className={cx("info")}
                onClick={() => {
                  setIsFormTime(!isFormTime);
                }}
              >
                <span ref={refBtn} className={cx("list-time")}>
                  {start && end && (
                    <Chip
                      title={`${convertTimePM(start)} - ${end === "00" ? "24" : convertTimePM(end)
                        }`}
                      onClose={() => 0}
                    />
                  )}
                </span>
              </span>
              {isFormTime && (
                <div ref={ref} className={cx("time")}>
                  <div className={cx("start")}>
                    <label className={cx("label-time")}>{t('smartReport.timeStart')}</label>
                    <input
                      value={start}
                      onChange={(e) => {

                        setShowReload(true)
                        setStart(e.target.value)

                      }}
                      className={cx("input-time")}
                      type={"time"}
                    />
                  </div>
                  <div
                    onChange={(e) => {
                      setShowReload(true)
                      setEnd(e.target.value)

                    }}
                    className={cx("end")}
                  >
                    <label className={cx("label-time")}>{t('smartReport.timeEnd')}</label>
                    <input value={end} className={cx("input-time")} type={"time"} />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {nameService === "Cảnh báo cháy"
          ? titleAlrm?.length > 0 &&
          titleAlrm.map((param, index) => {
            return (
              <div className={cx("item-setting")} key={index}>
                <span className={cx("name")}>{listParamTranslate.find(par => par.param_name === param.DESCRIBE)?.name_tr || param.DESCRIBE}</span>
                <span className={cx("info")}>
                  {param.DESCRIBE === "Khoảng cách" ? (
                    <input
                      onChange={(e) => {
                        setShowReload(true)
                        setConfigAlrm({
                          ...configAlrm,
                          [`${param?.PARAM}`]: e.target.value,
                        })
                      }
                      }
                      max={14}
                      min={1}
                      className={cx("date")}
                      type="number"
                      value={configAlrm ? configAlrm[`${param?.PARAM}`] : ''}
                    />
                  ) : (param.PARAM === "alarm" ?
                    <>
                      <input
                        onChange={(e) => {
                          setShowReload(true)
                          setConfigAlrm({
                            ...configAlrm,
                            [`${param?.PARAM}`]: e.target.value,
                          })
                        }
                        }
                        style={{ marginTop: 8, marginRight: 36 }}
                        type="range"
                        id="vol"
                        value={configAlrm ? configAlrm[`${param?.PARAM}`] : ''}
                        name="vol"
                        step={0.5}
                        min="-20"
                        max="150"
                      />
                      <InputNumber
                        min={-20}
                        max={150}
                        step={0.1} // bước nhảy cho số thập phân
                        precision={1} // tối đa 2 chữ số thập phân
                        defaultValue={0}
                        value={Number(configAlrm ? configAlrm[`${param?.PARAM}`] : '')}
                        onChange={(e) => {
                          setConfigAlrm({
                            ...configAlrm,
                            [`${param?.PARAM}`]: e,
                          })
                          setShowReload(true)
                        }
                        }
                      // style={{ width: 200 }}
                      />
                    </> : <></>
                  )}
                </span>
              </div>
            );

          })
          : listParamsConfig?.length > 0 &&
          listParamsConfig.map((param, index) => {
            if (typeCamera === "HIK" && param.DESCRIBE === "Độ nhạy" && nameService === "Cảnh báo cháy" && param?.PARAM === 'alarm') {
              return (
                <div className={cx("item-setting")} key={index}>
                  <span className={cx("name")}>{listParamTranslate.find(par => par.param_name === param.DESCRIBE)?.name_tr || param.DESCRIBE}</span>
                  <span className={cx("info")}>
                    <input
                      onChange={(e) => {
                        setShowReload(true)
                        setNhay(e.target.value)
                      }}
                      style={{ marginTop: 8 }}
                      type="range"
                      id="vol"
                      value={nhay}
                      name="vol"
                      step={20}
                      min="0"
                      max="100"
                    />
                    <span style={{ paddingLeft: 4, marginBottom: -4 }}>
                      {nhay}
                    </span>
                  </span>
                </div>
              );
            } else {
              if (typeCamera === "HIK" && nameService === "Cảnh báo cháy") {
                return <></>;
              } else {
                return (
                  <div className={cx("item-setting")} key={index}>
                    <span className={cx("name")}>{listParamTranslate.find(par => par.param_name === param.DESCRIBE)?.name_tr || param.DESCRIBE}</span>
                    <span className={cx("info")}>
                      <SelectBox
                        onChange={(data) => {
                          setShowReload(true)
                          changeInfoParam(data, param.AI_PARAM_CODE);
                        }}
                        values={listParamLevelTranslate?.find(parLev => parLev.param_name === param.DEFAULT_LEVEL_NAME)?.name_tr || param.DEFAULT_LEVEL_NAME}
                        className={cx("quality")}
                        type="small"
                        select
                        style={{ marginTop: "25px", minWidth: "170px" }}
                      >
                        {param.LEVEL?.length > 0 &&
                          param.LEVEL?.map((item, index) => {
                            return (
                              <SelectBoxItem
                                label={listParamLevelTranslate?.find(parLev => parLev.param_name === item.PARAM_LEVEL)?.name_tr || item.PARAM_LEVEL}
                                value={item.CODE}
                                key={index}
                              />
                            );
                          })}
                      </SelectBox>
                    </span>
                  </div>
                );
              }
            }
          })}
      </div>
      {
        // permissionChange &&
        // (listParamsConfig.length > 0 || titleAlrm.length > 0) && (
        <div className={cx("actions-setting")}>
          <Button
            onClick={handleResetConfig}
            className={cx("btn-save")}
            title={t('setting.Reset_to_default')}
          />
          {showReload && <Button
            className={cx("btn-cancle")}
            title={t('stream.cancelCustom')}
            onClick={handleCancel}
          />}
          <Button
            onClick={handleUpdate}
            className={cx("btn-save")}
            title={t('settingCam.Save_settings')}
          />
        </div>
        // )
      }
    </>
  );
}

export default ConfigValue;